
    import {wrap} from 'comlink';
    const createWorker = () => {
      const worker = new Worker(__webpack_public_path__ + "js/download-project.d6f411275499235a1d84.worker.js");
      const terminate = () => {
        worker.terminate();
      };
      const wrapped = wrap(worker);
      return {worker: wrapped, terminate};
    };
    export default createWorker;
    